import AllhomesAuthentication from './allhomes-authentication';
export default AllhomesAuthentication;